import { render, staticRenderFns } from "./LabelReps.vue?vue&type=template&id=74290d4e&scoped=true"
import script from "./LabelReps.vue?vue&type=script&lang=js"
export * from "./LabelReps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74290d4e",
  null
  
)

export default component.exports